import React from 'react';
import { LoadingIndicator } from 'lib/components';
import { Flex } from 'lib/components/styles/layout';
import { BackgroundCard } from './BackgroundCard';
import {
  EmptySearchText,
  EmptySearchWrapper,
} from 'app/pages/admin/landing-pages-v2/styles';
import { IBackgroundResponse } from 'lib/api/backgrounds/useQueryBackgrounds';
import { useIsMutating } from 'react-query';
import { CSSProperties } from 'styled-components/macro';
import { FormikHelpers } from 'formik';
import { ICreateSpotlightFormikValues } from '../../aiSpotlight/modal/types';

interface IBackgroundsListProps {
  backgrounds: IBackgroundResponse[];
  selectedBackground?: number;
  isLoading: boolean;
  onDefaultBackgroundChange: (
    backgroundId: number,
    formikHelpers?: FormikHelpers<ICreateSpotlightFormikValues>
  ) => void;
  selectedText: string;
  unselectedText: string;
  extendStyles?: {
    list?: {
      wrapperStyles?: CSSProperties;
    };
    card?: {
      cardWrapperStyles?: CSSProperties;
    };
  };
}

export const BackgroundList = ({
  backgrounds,
  selectedBackground,
  isLoading,
  onDefaultBackgroundChange,
  selectedText,
  unselectedText,
  extendStyles,
}: IBackgroundsListProps) => {
  const isMutating = useIsMutating();
  const isDisabled = isMutating > 0;
  const isProcessing = isLoading || isDisabled;

  return (
    <Flex
      width='100%'
      flexDirection='row'
      gap='27px'
      justifyContent='flex-start'
      flexWrap='wrap'
      style={{
        ...extendStyles?.list?.wrapperStyles,
        position: 'relative',
      }}
    >
      {isLoading ? (
        <div style={{ height: '200px' }}>
          <LoadingIndicator isLoading={isLoading} />
        </div>
      ) : (
        <>
          {backgrounds.length > 0 ? (
            backgrounds.map(background => (
              <BackgroundCard
                key={background.backgroundId}
                background={background}
                selectedBackground={
                  selectedBackground === undefined
                    ? undefined
                    : background.backgroundId === selectedBackground
                }
                isLoading={isProcessing}
                onDefaultBackgroundChange={onDefaultBackgroundChange}
                selectedText={selectedText}
                unselectedText={unselectedText}
                extendStyles={{ ...extendStyles?.card }}
              />
            ))
          ) : (
            <EmptySearchWrapper>
              <EmptySearchText>
                There are no Backgrounds available.
              </EmptySearchText>
            </EmptySearchWrapper>
          )}
        </>
      )}
    </Flex>
  );
};
